import React, { useState } from 'react';
import { has } from 'lodash';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';

import DateFnsUtils from '@date-io/date-fns';

import {
  TextField,
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  IconButton,
  FormHelperText,
} from '@material-ui/core';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import PhoneNumber from 'components/ui/PhoneNumber';

const GeneralInfoFormFields = ({
  firstName,
  lastName,
  email,
  password,
  passwordConfirmation,
  phone,
  phoneRequired,
  dateOfBirth,
  errors,
  touched,
  handleChange,
  showPasswordFields,
  setFieldValue,
  showBirthDate,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleClickShowConfirmPassword = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <TextField
        color="primary"
        error={touched.firstName && has(errors, 'firstName')}
        helperText={touched.firstName && errors.firstName}
        label="First Name"
        name="firstName"
        onChange={handleChange}
        value={firstName}
        variant="outlined"
        required
        autoComplete="chrome-off"
      />

      <TextField
        color="primary"
        error={touched.lastName && has(errors, 'lastName')}
        fullWidth
        helperText={touched.lastName && errors.lastName}
        label="Last Name"
        name="lastName"
        onChange={handleChange}
        value={lastName}
        variant="outlined"
        required
        autoComplete="chrome-off"
      />

      <TextField
        color="primary"
        error={touched.email && has(errors, 'email')}
        fullWidth
        helperText={touched.email && errors.email}
        label="Email"
        name="email"
        onChange={handleChange}
        value={email}
        type="email"
        variant="outlined"
        required
        autoComplete="chrome-off"
      />

      <PhoneNumber
        label="Phone Number"
        errors={errors}
        touched={touched}
        handleChange={handleChange}
        value={phone}
        name="phone"
        required={phoneRequired}
      />

      {showBirthDate && (
        <KeyboardDatePicker
          format="MM/dd/yyyy"
          disableToolbar
          variant="inline"
          fullWidth
          label="Date of Birth (MM/DD/YYYY)"
          name="dateOfBirth"
          onChange={(value) => setFieldValue('dateOfBirth', value)}
          required
          value={dateOfBirth}
          KeyboardButtonProps={{ 'aria-label': 'change date' }}
          error={touched.dateOfBirth && has(errors, 'dateOfBirth')}
          inputVariant="outlined"
          helperText={touched.dateOfBirth && errors.dateOfBirth}
        />
      )}

      {showPasswordFields && (
        <>
          <FormControl variant="outlined">
            <InputLabel
              htmlFor="outlined-adornment-password"
              error={touched.password && has(errors, 'password')}
              helperText={touched.password && errors.password}
              required
            >
              Password
            </InputLabel>
            <OutlinedInput
              id="outlined-adornment-password"
              type={showPassword ? 'text' : 'password'}
              value={password}
              name="password"
              error={touched.password && has(errors, 'password')}
              helperText={touched.password && errors.password}
              required
              onChange={handleChange}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              }
              labelWidth={75}
            />

            {errors.password && touched.password && (
              <FormHelperText error={has(errors, 'password')}>
                {errors.password}
              </FormHelperText>
            )}
          </FormControl>

          <FormControl variant="outlined">
            <InputLabel
              htmlFor="outlined-adornment-password"
              error={touched.password && has(errors, 'passwordConfirmation')}
              helperText={
                touched.passwordConfirmation && errors.passwordConfirmation
              }
              required
            >
              Confirm Password
            </InputLabel>
            <OutlinedInput
              id="outlined-adornment-password"
              type={showConfirmPassword ? 'text' : 'password'}
              value={passwordConfirmation}
              name="passwordConfirmation"
              onChange={handleChange}
              required
              error={
                touched.passwordConfirmation &&
                has(errors, 'passwordConfirmation')
              }
              helperText={
                touched.passwordConfirmation && errors.passwordConfirmation
              }
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowConfirmPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              }
              labelWidth={150}
            />

            {errors.passwordConfirmation && touched.passwordConfirmation && (
              <FormHelperText error={has(errors, 'passwordConfirmation')}>
                {errors.passwordConfirmation}
              </FormHelperText>
            )}
          </FormControl>
        </>
      )}
    </MuiPickersUtilsProvider>
  );
};

export default GeneralInfoFormFields;
